import { render, staticRenderFns } from "./UserChipLogsCard.vue?vue&type=template&id=5a63be97&"
import script from "./UserChipLogsCard.vue?vue&type=script&lang=js&"
export * from "./UserChipLogsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserChipLogsCard.vue?vue&type=style&index=0&id=5a63be97&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports